import { Box, Button, NoticeBox } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onDeleteBreak: () => void
}

const BreakWarning = ({ onDeleteBreak }: Props) => {
  return (
    <Box flexDirection="row" gap="s16">
      <NoticeBox
        message={i18n.t('shift_management.planned_breaks.archived.warning_rotating')}
        borderRadius={{ all: 'abs008' }}
      />
      <Box paddingTop="s6">
        <Button type="secondary" onClick={onDeleteBreak} iconName="delete" />
      </Box>
    </Box>
  )
}

export default observer(BreakWarning)
